module.exports = __webpack_public_path__ + "img/xuzhou.033e03a4.jpg";